import React from "react";

function errorMessage(error) {
  let message = "Error message!";
  switch (error.code) {
    case "auth/email-already-in-use":
      message = "Email Already in Use";
      break;
    case "auth/invalid-email":
      message = "Enter Email is Invalid";
      break;
    case "auth/weak-password":
      message = "Enter password is weak use Strong password";
      break;
    case "auth/user-not-found":
      message = "Email Not Found register First";
      break;
    case "auth/user-disabled":
      message = "User has been disabled Connect Support For More Info";
      break;
    case "auth/app-deleted":
      message = "Sorry FirebaseApp has been deleted";
      break;
    case "auth/expired-action-code":
      message = "Request TimeOut!";
      break;
  }

  return message;
}

export default errorMessage;
